Core.DatePicker2 = function(elem) {
    var IPAD_WIDTH_RESOLUTION = 1081;

    function executeCallback(clb) {
        clb();
    }

    function filler(dateNumber) {
        return ('' + dateNumber).length < 2
            ? '0' + dateNumber
            : '' + dateNumber;
    }

    /*


        DOM Check


     */

    // -- STR -- DOM --------------
    function isInputText() {
        return elem.nodeName === 'INPUT' && elem.type === 'text';
    }

    function hasAlreadyPicker2Class() {
        return elem.classList.contains("datePicker2")
    }

    function isNumberSlash(key) {
        return /[0-9\/]/.test(key);
    }

    function isTab(key) {
        return key === 'Tab';
    }

    function isSlash(key) {
        return key === '/';
    }

    function isBackspace(key) {
        return key === 'Backspace';
    }

    function isArrowLeft(key) {
        return key === 'ArrowLeft';
    }

    function isArrowRight(key) {
        return key === 'ArrowRight';
    }

    function isArrow(key) {
        return isArrowLeft(key)
            || isArrowRight(key);
    }

    function isDayPosition(length) {
        return (length === 2);
    }

    function isSlashPosition(length) {
        return (length === 2 || length === 5);
    }

    function shouldBeSlash(length) {
        return (length === 3 || length === 6);
    }

    function isLastDigitMonthPosition(length) {
        return (length === 5);
    }

    function isMonthPosition(length) {
        return (length === 4);
    }

    function isFirstYearDigitPosition(length) {
        return (length === 7);
    }

    function isSecondYearDigitPosition(length) {
        return (length === 8);
    }

    function isOnSelection() {
        return (document.getSelection().focusNode === elem.parentNode)
            && (document.getSelection().toString().length > 0);
    }

    function getCursorPosition() {
        var input = elem;
        if (!input) return; // No (input) element found
        if ('selectionStart' in input) {
            // Standard-compliant browsers
            return input.selectionStart;
        } else if (document.selection) {
            // IE
            input.focus();
            var sel = document.selection.createRange();
            var selLen = document.selection.createRange().text.length;
            sel.moveStart('character', -input.value.length);
            return sel.text.length - selLen;
        }
    }

    function isInCurrentPosition(length) {
        return getCursorPosition() === length;
    }
    // -- END -- DOM --------------


    /*


        TIME


     */
    // -- STR -- TIME --------------
    function getYearsRange() {
        var currentYear = new Date().getFullYear();
        var years = [];

        for (var i = currentYear - 120; i < currentYear + 20; i++) {
            years.push({
                value: i,
                text: i
            });
        }

        return years;
    }

    function getMonthsRange(year) {
        var months = [];

        for (var i = 1; i <= 12; i++) {
            months.push({
                value: i,
                text: i
            });
        }

        return months;
    }

    function getDaysRange(year, month) {
        var dayCount = new Date(year, month, 0).getDate();
        var days = [];

        for (var i = 1; i <= dayCount; i++) {
            days.push({
                value: i,
                text: i
            });
        }

        return days;
    }

    function isValidPartialDateFormat(dateString) {
        var reIsNumber =  new RegExp('[0-9]');
        var reIsSlash =  new RegExp('^[/]{1}$');

        var date = Array.from(dateString);
        var date_sequence = [
            reIsNumber,
            reIsNumber,
            reIsSlash,

            reIsNumber,
            reIsNumber,
            reIsSlash,

            reIsNumber,
            reIsNumber,
            reIsNumber,
            reIsNumber,
        ];

        if (date.length === 0) {
            return true;
        }

        if (date.length > 10) {
            return false;
        }

        return date.reduce(function(previousValue, currentValue, currentIndex) {
            return date_sequence[currentIndex].test(currentValue) && previousValue;
        }, true);
    }

    /*

        Check if in DD/MM/YYYY format

     */
    function isValidFormatDate(dateString) {
        return /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})/.test(dateString);
    }

    /*

        @param string dateString
        @return obj {day: number, month: number, year: number}

     */
    function splitInputValues(dateString) {
        // ['10/05/2022', '10', '05', '2022', index: 0, input: '10/05/2022', groups: undefined]
        var found = dateString.match(/([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})/);

        return {
            day: parseInt(found[1]),
            month: parseInt(found[2]),
            year: parseInt(found[3]),
        };
    }

    /*

        @return obj {day: number, month: number, year: number}

     */
    function getCurrentDate() {
        var now = new Date();

        return {
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            day: now.getDate(),
        };
    }

    function getDate() {
        var dateString = elem.value.toString();

        return isValidFormatDate(dateString)
            ? splitInputValues(dateString)
            : getCurrentDate();
    }
    // -- END -- TIME --------------


    /*


        UTILS


     */
    // -- STR -- UTILS --------------
    function getPlaceholderValue(value) {
        var defaultPlaceholder = 'DD/MM/YYYY';

        return value
                ? '<i>' + value + '</i>' + defaultPlaceholder.slice(value.length)
                : defaultPlaceholder;
    }
    // -- END -- UTILS --------------

    var el = {
        elem: elem,
        cover: document.createElement('div'),
        wrapper: document.createElement('div'),
        placeholder: document.createElement('span'),
    };

    var data = {
        selectorDay: '',
        selectorMonth: '',
        selectorYear: '',

        _inputValue: '',

        subscriberList: {
            inputValue: [],
        },

        set inputValue(value) {
            this._inputValue = value;

            data.subscriberList.inputValue.forEach(executeCallback);
        },

        get inputValue() {
            return this._inputValue;
        },

        subscribe(name, callback) {
            data.subscriberList[name].push(callback);
        },
    };


    // Methods
    var m = {
        init: function() {
            if (! isInputText()) {
                console.error('Invalid input element provided : ' + elem.nodeName);
                return;
            }

            if (hasAlreadyPicker2Class()) {
                console.warn('Date Picker 2 already init');
                return;
            }

            m.boot();
        },

        boot: function() {
            m.loadVar();
            m.loadCallback();

            m.initWrapper();
            m.initCover();
            m.initPlaceholder();
            m.updatePlaceholder(el.elem.value);
            m.composeDOMToWrapper();

            m.initOnKeyDownAndUp();
            m.initOnEsc();
            m.initOnCoverClickShowSelector();
            m.initOnWindowResize();
            m.initMutatorCheckForDisabled();

            m.initKendoPicker();
        },

        initKendoPicker: function() {
            if (elem.classList.contains('show-picker')) {
                $(elem).kendoDatePicker({
                    format: "dd/MM/yyyy",
                    change: function() {
                        data.inputValue = el.elem.value;
                        m.updatePlaceholder();
                    },
                });
            }
            
        },

        loadVar: function() {
            data.inputValue = el.elem.value;
        },

        loadCallback: function() {
            data.subscribe('inputValue', m.updatePlaceholder)
        },

        /*


            EVENTS
            - initOnKeyDownAndUp : when typing
            - initOnEsc : getting out of selector view


         */

        // --- STR - EVENTS  --------------
        initOnKeyDownAndUp: function() {
            var doCheckValidKeyAndUpdatePlaceholder = function(e) {
                var dataValue = el.elem.value.split(' ').join('').split('.').join(''); // mac double space add .
                el.elem.value = dataValue;
                var lastChar = dataValue[dataValue.length - 1];

                if (! isNumberSlash(e.key) && ! isTab(e.key) && ! isBackspace(e.key) && !isArrow(e.key)) {
                    e.preventDefault();
                    return;
                }

                if (! isTab(e.key) && ! isBackspace(e.key) && !isArrow(e.key) && !isOnSelection() && el.elem.value.length >= 10) {
                    e.preventDefault();
                    return;
                }

                if (dataValue[getCursorPosition() - 1] === '/' && e.key === '/') {
                    e.preventDefault();
                    return;
                }

                isNumberSlash(e.key)
                    && (data.inputValue = el.elem.value.trim() + e.key);
            };

            var doPolishInput = function(e) {
                var dataValue = el.elem.value.split(' ').join('').split('.').join(''); // mac double space add .
                el.elem.value = dataValue;
                var lastChar = dataValue[dataValue.length - 1];
                var prevLastChar = dataValue[dataValue.length - 2];


                // case 1/ -> 01/
                ! isBackspace(e.key)
                    && !isArrow(e.key)
                    && isSlash(lastChar)
                    && isInCurrentPosition(el.elem.value.length)
                    && isDayPosition(el.elem.value.length)
                    && ( el.elem.value = '0' + dataValue
                       , dataValue = el.elem.value
                       );

                // case 01/1/ -> 01/01/
                ! isBackspace(e.key)
                    && !isArrow(e.key)
                    && isSlash(lastChar)
                    && isInCurrentPosition(el.elem.value.length)
                    && isLastDigitMonthPosition(el.elem.value.length)
                    && ( el.elem.value = dataValue.slice(0, -2) + '0' + dataValue.slice(-2)
                       , dataValue = el.elem.value
                       );


                // check if we are in a slash position
                // if so and it's a number
                // then swap and insert slash
                // case 01 -> 01/
                // case 01/01 -> 01/01/
                ! isBackspace(e.key)
                    && !isArrow(e.key)
                    && !isSlash(lastChar)
                    && isInCurrentPosition(el.elem.value.length)
                    && shouldBeSlash(el.elem.value.length)
                    && ( el.elem.value = dataValue.slice(0, -1) + '/' + lastChar
                       , dataValue = el.elem.value
                       );


                // check that the first month int is 1 or 0
                // else swap and add 0
                // case 10/5 -> 10/05

                ! isBackspace(e.key)
                    && !isArrow(e.key)
                    && !isSlash(lastChar)
                    && isInCurrentPosition(el.elem.value.length)
                    && isMonthPosition(el.elem.value.length)
                    && (e.key !== '1' && e.key !== '0')
                    && (el.elem.value = dataValue.slice(0, -1) + '0' + lastChar + '/'
                       , lastChar = '/'
                       , dataValue = el.elem.value
                       );

                // check if after all the data manipulation
                // we are in slash position
                // if so add slash
                ! isBackspace(e.key)
                    && !isArrow(e.key)
                    && !isSlash(lastChar)
                    && isInCurrentPosition(el.elem.value.length)
                    && isSlashPosition(el.elem.value.length)
                    && (el.elem.value += '/'
                       , dataValue = el.elem.value
                       );

                data.inputValue = el.elem.value;
            };

            el.elem.addEventListener('keydown', doCheckValidKeyAndUpdatePlaceholder);
            el.elem.addEventListener('keyup', doPolishInput);
            el.elem.addEventListener('change', m.updatePlaceholder);
            el.elem.addEventListener('blur', m.updateCurrentInputFillerDate);
        },

        initOnEsc: function() {
            var removeOnEsc = function(e) {
                (e.key === 'Escape') && m.removeSelector();
            };

            document.removeEventListener('keydown', removeOnEsc);
            document.addEventListener('keydown', removeOnEsc);
        },

        initOnCoverClickShowSelector: function() {
            el.cover.addEventListener('click', m.showSelector);
        },

        initOnWindowResize: function() {
            window.addEventListener('resize', function(e) {
                (window.innerWidth < IPAD_WIDTH_RESOLUTION)
                    && m.removeSelector();
            });
        },

        initMutatorCheckForDisabled: function() {
            var hideCover = function() {
                el.cover.classList.remove('d-block');
                el.cover.classList.remove('d-lg-none');
                el.cover.classList.add('d-none');
            }

            var showCover = function() {
                el.cover.classList.add('d-block');
                el.cover.classList.add('d-lg-none');
                el.cover.classList.remove('d-none');
            }

            const observer = new MutationObserver(function() {
                (el.elem.disabled)
                    ? hideCover()
                    : showCover();
            });

            observer.observe(elem, {attributes: true});
        },
        // --- END - EVENTS  --------------


        /*

            DOM
            - initWrapper : add classes to wrap
            - initCover : add classes to cover
            - initPlaceholder : add classes to placeholder

            - updatePlaceholder : update placeholder ui

            - composeDOMToWrapper : append [cover, placeholder input] to the wrapper

         */

        // --- STR - DOM  --------------
        initWrapper: function() {
            [ "datePicker2-wrapper"
            , "form-input"
            , "position-relative"].forEach((itm) => el.wrapper.classList.add(itm));
        },

        initCover: function() {
            el.cover.classList.add('datePicker2-cover');
            el.cover.classList.add('d-block');
            el.cover.classList.add('d-ipad-none');
        },

        initPlaceholder: function() {
            el.placeholder.classList.add('datePicker2-placeholder');
            el.placeholder.setAttribute('aria-hidden', true);
        },

        updatePlaceholder: function() {
            el.placeholder.innerHTML = isValidPartialDateFormat(data.inputValue)
                                        ? getPlaceholderValue(data.inputValue)
                                        : '';
        },

        updateCurrentInputFillerDate: function() {
            var dateObj;
            var isValidLength = function(chunk) {
                 return chunk.length > 0;
            };

            isValidFormatDate(el.elem.value)
                && ( el.elem.value.split('/').filter(isValidLength).length === 3 )
                && ( dateObj = splitInputValues(el.elem.value)
                   , m.updateInputFillerDate(dateObj.day, dateObj.month, dateObj.year)
                   );
        },

        updateInputFillerDate: function(day, month, year) {
            el.elem.value = filler(day) + '/' + filler(month) + '/' + year;
        },

        composeDOMToWrapper: function() {
            elem.parentNode.insertBefore(el.wrapper, elem);
            el.wrapper.appendChild(el.cover);
            el.wrapper.appendChild(el.placeholder);
            el.wrapper.appendChild(elem);

            elem.classList.add('datePicker2');
        },

        updateInputFromSelector: function() {
            m.updateInputFillerDate(data.selectorDay, data.selectorMonth, data.selectorYear);

            var event = new Event('change');
            el.elem.dispatchEvent(event);
        },
        // --- END - DOM  --------------


        /*

            SELECTOR
            - showSelector : append html and init js
            - removeSelector : remove html
            - initSelectors : init js
                + if already has value
                + if no value
                + on confirm
         */

        // --- STR - SELECTOR  --------------
        showSelector: function() {
            var select = document.createElement('div');
            select.classList.add('datePicker2-select');
            select.innerHTML = `
                <div class="datePicker2-wrapperMobile position-fixed k-overlay" data-cancel></div>

                <div class="datePicker2-datePanel animated slideInDown fast">
                    <header class="d-flex px-3 justify-between border-bottom border-extra-light-grey">
                        <button class="btn-link" data-cancel>Cancel</button>
                        <button class="btn-link" data-confirm>Confirm</button>
                    </header>

                    <div class="date-selector">
                        <div class="day" id="day"></div>
                        <div class="month" id="month"></div>
                        <div class="year" id="year"></div>
                    </div>
                </div>`;

            document.body.appendChild(select);

            Array
                .from(select.querySelectorAll('[data-cancel]'))
                .forEach(function(cancelItem) { cancelItem.addEventListener('click', m.removeSelector); });

            Array
                .from(select.querySelectorAll('[data-confirm]'))
                .forEach(function(confirmItem) {
                    confirmItem.addEventListener('click', function() {
                        m.updateInputFromSelector();
                        data.inputValue = el.elem.value;
                        m.removeSelector();
                    });
                });

            m.initSelectors();
        },

        removeSelector: function() {
            var select = document.querySelector('.datePicker2-select');

            select
                && select.parentNode
                && select.parentNode.removeChild(select);
        },

        initSelectors: function() {
            var initialDate = getDate();

            data.selectorYear = initialDate.year;
            data.selectorMonth = initialDate.month;
            data.selectorDay = initialDate.day;

            var yearSource = getYearsRange();
            var monthSource = getMonthsRange();
            var daySource = getDaysRange(initialDate.year, initialDate.month);

            var yearSelector = new IosSelector({
                el: '#year',
                type: 'infinite',
                source: yearSource,
                count: 20,
                value: initialDate.year,
                onChange: (selected) => {
                    data.selectorYear = selected.value;

                    var daySource = getDaysRange(data.selectorYear, data.selectorMonth);
                    daySelector.updateSource(daySource);
                }
            });

            var monthSelector = new IosSelector({
                el: '#month',
                type: 'infinite',
                source: monthSource,
                count: 20,
                value: initialDate.month,
                onChange: (selected) => {
                    data.selectorMonth = selected.value;

                    var daySource = getDaysRange(data.selectorYear, data.selectorMonth);
                    daySelector.updateSource(daySource);
                }
            });

            var daySelector = new IosSelector({
                el: '#day',
                type: 'infinite',
                source: daySource,
                count: 20,
                value: initialDate.day,
                onChange: (selected) => {
                    data.selectorDay = selected.value;
                }
            });
        },
        // --- END - SELCTOR  --------------
    };

    return m;

};
